module.exports = __webpack_public_path__ + "static/media/last-minute-gear-james-dong.5157a8fd.jpg";